import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import {
  Visibility,
  Download,
  PagesRounded,
  ShieldMoon,
  AddCircleOutline,
  Delete,
  DeleteOutline,
} from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "../../assets/scss/styles/timeline.css";
import { Link } from "react-router-dom";

function View(props) {
  const [orderData, setOrderData] = useState([]);
  const [comment, setComment] = useState("");
  const [rejected, setRejected] = useState(true);
  const [status, setStatus] = useState("");
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1200);
  const [page, setPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [bmErrors, setBmErrors] = useState({});
  const [itemList, setItemList] = useState([]);
  const dispatch = useDispatch();
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [deletedMaterial, setDeletedMaterial] = useState([]);
  const [bmNote, setbmNote] = useState("");
  const [marketingDynamic, setMarketingDynamic] = useState([
    {
      item: "",
      qty: "",
      id: "0",
      status: "",
      marketPrice: "",
    },
  ]);

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  const [loadingAccept, setLoadingAccept] = useState(false); // State to manage loading for Accept button
  const [loadingReject, setLoadingReject] = useState(false);
  const [isShowEditMM, setIsShowEditMM] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [hasSaved, setHasSaved] = useState(false);

  // const isBrandManager = userProfile?.user_role.filter(role => role.roleName === "Brand Manager").length ?? 0;

  const isBrandManager = utils.hasPermission(
    primaryMenuRes,
    "Sales Order",
    "sales_order.Brand_Manager_permissions"
  );

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  const columns = [
    {
      name: "Name",
      selector: (row) => row.username,
    },
    {
      name: "Order Date",
      selector: (row) => moment(row.createdAt).format("DD-MM-yyyy"),
    },
    {
      name: "Order Time",
      selector: (row) => moment(row.createdAt).format("HH:mm:ss"),
    },
    {
      name: "Order No",
      selector: (row) => row?.order_no,
    },
    {
      name: "Type",
      selector: (row) => row.type,
    },
  ];

  useEffect(() => {
    getOrderList();
  }, [page]);

  useEffect(() => {
    getItemList();
  }, [isEditing]);

  const getItemList = (index) => {
    var bodyFormData = new FormData();

    bodyFormData.append("id", "");
    bodyFormData.append("page", "");
    bodyFormData.append("per_page", "");

    utils
      .callAPI("post", `/sales/getmarketingList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setItemList(res.result);
        } else {
          setItemList([]);
        }
      })
      .catch((err) => {
        setItemList([]);
      });
  };

  useEffect(() => {
    console.log("Here is the orders", orderData?.material);
    if (orderData !== [])
      setMarketingDynamic(
        orderData?.material?.map((material) => ({
          item: material.marketing_material_id,
          qty: material.qty,
          id: material.id,
          marketPrice: material.price,
        }))
      );
  }, [isEditing, orderData]);

  const updateMarketingMaterial = () => {
    const requestData = {
      order_id: orderData.id,
      bm_note: bmNote,
      material: marketingDynamic.map((field, index) => ({
        id: field.id || "0",
        marketing_material_id: field.item || "",
        qty: field.qty || "",
        price: field.marketPrice || "",
        total: "",
      })),

      material_delete: deletedMaterial.map((field, index) => ({
        id: field.id || "0",
        marketing_material_id: field.item || "",
        qty: field.qty || "",
        price: field.marketPrice || "",
        total: "",
      })),
    };

    console.log("yeh ja raha hai bhai", requestData);

    // Remove undefined fields
    const cleanedRequestData = JSON.parse(
      JSON.stringify(requestData, (key, value) =>
        value === undefined ? undefined : value
      )
    );

    utils
      .callAPI("post", `/sales/update_marketing_material`, cleanedRequestData)
      .then((res) => {
        if (typeof res !== "undefined") {
          getOrderList();
          setbmNote("");
          setBmErrors("");
        } else {
          getOrderList();
        }
      })
      .catch((err) => {
        // setQuotationList([]);
      });
  };

  const getOrderList = () => {
    var bodyFormData = new FormData();

    const orderId =
      props?.rowData?.orderdata && props?.rowData?.orderdata.id
        ? props?.rowData?.orderdata.id
        : props?.rowData?.id;

    bodyFormData.append("order_by", "");
    // bodyFormData.append("id", props?.rowData?.id);
    bodyFormData.append("id", orderId);
    bodyFormData.append("page", page);
    bodyFormData.append("per_page", countPerPage);

    utils
      .callAPI("post", `/sales/getOrdersList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setOrderData(res.result[0]);
          if (
            res.result[0].remarks !== "" &&
            res.result[0].approve_status !== "0"
          ) {
            setComment(res.result[0].remarks);
          } else {
            setComment("");
          }

          const piResponse = res.result[0]?.pi_response;

          if (
            isBrandManager &&
            piResponse?.brand_manager_material_status === "0"
          ) {
            setIsShowEditMM(true);
          }
        } else {
          setOrderData([]);
          setComment("");
          setIsShowEditMM(false);
        }
      })
      .catch((err) => {
        setOrderData([]);
        setComment("");
      });
  };

  const validate = () => {
    const newErrors = {};
    if (!comment) {
      newErrors.note = "Comment is required";
    }
    return newErrors;
  };

  const sendStatus = (type) => {
    // const validationErrors = validate();
    // if (Object.keys(validationErrors).length > 0) {
    //   setErrors(validationErrors);
    //   return;
    // }
    if (type === "accept") {
      setLoadingAccept(true); // Start loader for Accept button
    } else if (type === "reject") {
      setLoadingReject(true); // Start loader for Reject button
    }
    var bodyFormData = new FormData();
    if (status !== "") {
      //  bodyFormData.append("order_by", userProfile?.id);
      bodyFormData.append("id", props?.rowData?.id);
      bodyFormData.append("status", status);
      bodyFormData.append("remarks", comment);
      utils
        .callAPI("post", `/sales/approve_by_reporting_manager`, bodyFormData)
        .then((res) => {
          if (type === "accept") {
            setLoadingAccept(false); // Stop loader for Accept button
          } else {
            setLoadingReject(false); // Stop loader for Reject button
          }
          if (typeof res !== "undefined") {
            Swal.fire({
              title: "Success!",
              text:
                status === "1"
                  ? "The order has been accepted."
                  : "The order has been rejected.",
              icon: "success",
              confirmButtonText: "OK",
            });

            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            if (type === "accept") {
              setLoadingAccept(false); // Stop loader on error for Accept button
            } else {
              setLoadingReject(false); // Stop loader on error for Reject button
            }
            //  setQuotationList([]);
          }
        })
        .catch((err) => {
          Swal.fire({
            title: "Error!",
            text: "There was an error processing your request.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const handleBackClick = (e) => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Trim only leading spaces
    const trimmedLeadingSpacesValue = value.replace(/^\s+/, "");

    if (name === "comment") {
      setComment(trimmedLeadingSpacesValue);
      console.log(errors, "yeh hai");

      // Clear validation error for the 'note' field when user starts typing
      setErrors((prevErrors) => ({
        ...prevErrors,
        note: trimmedLeadingSpacesValue ? "" : prevErrors.note,
      }));
    }
  };

  const handleBmChange = (e) => {
    const { name, value } = e.target;

    // Update the corresponding state based on the input name
    if (name === "bmNote") {
      setbmNote(value);
      console.log(errors, "yeh hai");

      setBmErrors((prevErrors) => ({
        ...prevErrors,
        note: value ? "" : prevErrors.note,
      }));
    }
  };

  useEffect(() => {
    // If there are no validation errors and status is set, call sendStatus
    if (status === "1" || status === "2") {
      if (status === "1") {
        sendStatus("accept");
      } else if (status === "2") {
        sendStatus("reject");
      }
    }
  }, [status, comment]);

  // const handleAcceptChange = (type) => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You want to Accept the Order!",
  //     icon: "warning",
  //     showDenyButton: true,
  //     confirmButtonText: "Yes",
  //     denyButtonText: "No",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       setStatus("1");
  //       sendStatus("accept");
  //     }
  //   });
  // };

  // const handleRejectChange = (type) => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You want to Reject the Order!",
  //     icon: "warning",
  //     showDenyButton: true,
  //     confirmButtonText: "Yes",
  //     denyButtonText: "No",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       setStatus("1");
  //       sendStatus("accept");
  //     }
  //   });
  // };

  const handleAccept = (e) => {
    //handleAcceptChange("accept");
    setStatus("1");
  };
  const handleReject = (e) => {
    // handleRejectChange("reject");
    const validationErrors = validate();
    setErrors(validationErrors);
    console.log("reject called");
    if (comment !== "") setStatus("2");
  };

  const handleEditClick = () => setIsEditing(true);
  const handleCancelMarketingField = () => setIsEditing(false);

  // Handle save and revert to original view
  const handleSaveClick = () => {
    // Your save logic here
    console.log(totalMarketQty);
    if (bmNote != "" && totalMarketQty > 0) {
      setIsEditing(false);
      // setHasSaved(true);
      updateMarketingMaterial();
    } else {
      if (bmNote === "") {
        setBmErrors({ note: "Note is Required" });
      } else {
        if (totalMarketQty == 0) {
          setBmErrors({ note: "Total quantity can not be 0." });
        }
      }
    }
  };

  const handleAddMarketingField = () => {
    setMarketingDynamic([
      ...marketingDynamic,
      {
        item: "",
        qty: "",
        id: "",
        marketPrice: "",
      },
    ]);
    //  setDynamicFieldsError("");
  };

  const handleRemoveMarketingField = (index, id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const fields = [...marketingDynamic];
        if (id > 0) {
          const deletedMaterial = fields.find((field) => field.id === id);

          // Update the deleted products array
          setDeletedMaterial((prevDeletedMaterial) => [
            ...prevDeletedMaterial,
            deletedMaterial,
          ]);
        }

        if (id > 0) {
          const removeIndex = fields.findIndex((field) => field.id === id);
          if (removeIndex > -1) fields.splice(removeIndex, 1);
        } else {
          fields.splice(index, 1);
        }

        setMarketingDynamic(fields);
      }
    });
  };

  const calculateTotalPrice = (salesPrice, qty) => {
    const price = parseFloat(salesPrice);
    const quantity = parseFloat(qty);
    if (!isNaN(price) && !isNaN(quantity)) {
      return (price * quantity).toFixed(2);
    }
    return "0.00";
  };

  const handleMarketDynamic = (index, event) => {
    const { name, value } = event.target;
    const fields = marketingDynamic.filter(
      (field) => field.status !== "deleted"
    );

    let validatedValue = value;

    if (name === "qty") {
      validatedValue = value.replace(/\D/g, "");
    }

    if (name === "item") {
      getItemPrice(value, index);
    }
    fields[index][name] = validatedValue;
    setMarketingDynamic(fields);
  };
  console.log("marketingDynamic", marketingDynamic);
  const totalMarketQty = marketingDynamic?.reduce((total, field) => {
    const qty = parseFloat(field.qty);
    return total + (isNaN(qty) ? 0 : qty);
  }, 0);
  console.log("totalMarketQty", totalMarketQty);

  const totalMarketPrice = marketingDynamic?.reduce((total, field) => {
    const price = parseFloat(field.marketPrice);
    const qty = parseFloat(field.qty);

    return total + (isNaN(price) || isNaN(qty) ? 0 : price * qty);
  }, 0);

  const getItemPrice = (id, index) => {
    var bodyFormData = new FormData();

    bodyFormData.append("id", id);
    bodyFormData.append("page", "");
    bodyFormData.append("per_page", "");

    utils
      .callAPI("post", `/sales/getmarketingList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          let itemPrice = res.result[0].item_price || "";
          console.log(itemPrice, "This is the price", res.result[0].item_price);
          const fields = [...marketingDynamic];
          fields[index].marketPrice = itemPrice;
          setMarketingDynamic(fields);
        } else {
          const fields = [...marketingDynamic];
          fields[index].marketPrice = "";
          setMarketingDynamic(fields);
        }
      })
      .catch((err) => {
        const fields = [...marketingDynamic];
        fields[index].marketPrice = "";
        setMarketingDynamic(fields);
      });
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header className="border-0">
          <h4></h4>
          <div className="card-header-action">
            <RB.Button className="btn btn-light" onClick={handleBackClick}>
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          {orderData.locationdata ? (
            <>
              <h6>Destination Center</h6>
              <hr className="hr-lg mt-1" />

              <RB.Row>
                <RB.Col md={6}>
                  <>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Office Address
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {orderData?.locationdata?.name}
                      <br />
                      {orderData?.locationdata?.address},<br />
                      {orderData?.locationdata?.city},<br />
                      {orderData?.locationdata?.state} -{" "}
                      {orderData?.locationdata?.pincode}
                      <br />
                      {/* GSTIN/UIN: {formData?.gstUin} <br />
                    State Name : {formData?.state}, Code : {formData?.stateCode} */}
                    </p>
                  </>
                </RB.Col>
              </RB.Row>
            </>
          ) : (
            ""
          )}
          <>
            <h6>Order Information</h6>
            <hr className="hr-lg mt-1" />
          </>
          <RB.Row>
            <RB.Col md={12}>
              <RB.Row className="mb-3">
                <RB.Col md={6}>
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    Order Id
                  </span>
                  <p className="fw-medium text-sm fw-semibold">
                    {orderData?.order_id}
                  </p>
                </RB.Col>
                <RB.Col md={6}>
                  <span className="text-uppercase fw-bold small text-body-secondary">
                    Order Date
                  </span>
                  <p className="fw-medium text-sm fw-semibold">
                    {orderData?.order_date}
                  </p>
                </RB.Col>
              </RB.Row>
            </RB.Col>
          </RB.Row>
          <>
            <h6>PO Details</h6>
            <hr className="hr-lg mt-1" />
          </>
          <RB.Row>
            <RB.Col md={12}>
              <RB.Row className="mb-3">
                {orderData?.po_no && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      PO Number
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {orderData?.po_no}
                    </p>
                  </RB.Col>
                )}
                {orderData?.po_date && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      PO Date
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {orderData?.po_date}
                    </p>
                  </RB.Col>
                )}

                {orderData?.po_remarks && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      PO Remark
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {orderData?.po_remarks}
                    </p>
                  </RB.Col>
                )}
              </RB.Row>
            </RB.Col>
          </RB.Row>

          <>
            <h6>Channel Details</h6>
            <hr className="hr-lg mt-1" />
          </>
          <RB.Row>
            <RB.Col md={12}>
              <RB.Row className="mb-3">
                {orderData?.channel_partner_type && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Channel Partner
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {orderData?.channel_partner_type}
                    </p>
                  </RB.Col>
                )}
                {orderData?.channel_name && (
                  <RB.Col md={6}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Channel Partner Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {orderData?.channel_name}
                    </p>
                  </RB.Col>
                )}
              </RB.Row>
            </RB.Col>
          </RB.Row>

          <>
            <h6>Channel Partner Contact</h6>
            <hr className="hr-lg mt-1" />
          </>

          <RB.Row>
            <RB.Col md={12}>
              <RB.Row className="mb-3">
                {orderData?.channel_partner_name && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Authorized Partner Name
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {orderData?.channel_partner_name}
                    </p>
                  </RB.Col>
                )}

                {orderData?.channel_partner_email && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Email
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {orderData?.channel_partner_email}
                    </p>
                  </RB.Col>
                )}

                {orderData?.channel_partner_no && (
                  <RB.Col md={4}>
                    <span className="text-uppercase fw-bold small text-body-secondary">
                      Mobile
                    </span>
                    <p className="fw-medium text-sm fw-semibold">
                      {orderData?.channel_partner_no}
                    </p>
                  </RB.Col>
                )}
              </RB.Row>
            </RB.Col>
          </RB.Row>
          <>
            <h6>Products</h6>
            <hr className="hr-lg mt-1" />
          </>

          <RB.Card>
            <RB.CardBody className="p-3">
              {isLargeScreen && (
                <RB.Card className="mb-2 bg-light-subtle1 border-0  card rounded-0 ">
                  <RB.CardBody className="p-0">
                    <RB.Row className="gx-3 gy-2 align-items-center mb-2">
                      <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-2 col-xxl-2">
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Product Category
                        </span>
                      </RB.Col>
                      <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-3 col-xxl-2">
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Product
                        </span>
                      </RB.Col>
                      <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-2 col-xxl-2">
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Actual Price
                        </span>
                      </RB.Col>
                      <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-2 col-xxl-2">
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Sales Price
                        </span>
                      </RB.Col>
                      <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-1 col-xxl-2">
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Qty
                        </span>
                      </RB.Col>
                      <RB.Col className="col-12 col-md-3 col-lg-4 col-xl-2 col-xxl-2 ">
                        <span className="text-uppercase fw-bold small text-body-secondary">
                          Total Price
                        </span>
                      </RB.Col>
                    </RB.Row>
                  </RB.CardBody>
                </RB.Card>
              )}
              {orderData?.product?.map((product, index) => (
                <RB.Card
                  className="mb-2 bg-light-subtle1 border-0 border-bottom border-dashed card rounded-0 "
                  key={product.id}
                >
                  <RB.CardBody className="p-0">
                    <RB.Row className="gx-3 gy-2 align-items-center">
                      <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-2 col-xxl-2 no-validation-icon">
                        <div className="mb-3">
                          <div className="floating-label-fancy">
                            <label>
                              {isLargeScreen ? "" : "Product Category"}
                            </label>
                            <div className="form-control-plaintext form-control-sm">
                              {product.category_name}
                            </div>
                          </div>
                        </div>
                      </RB.Col>

                      <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-3 col-xxl-2 no-validation-icon">
                        <div className="mb-3">
                          <div className="floating-label-fancy">
                            <label>{isLargeScreen ? "" : "Product"}</label>
                            <div className="form-control-plaintext form-control-sm">
                              {product.product_name}
                            </div>
                          </div>
                        </div>
                      </RB.Col>

                      <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-2 col-xxl-2 no-validation-icon">
                        <div className="mb-3">
                          <div className="floating-label-fancy">
                            <label>{isLargeScreen ? "" : "Actual Price"}</label>
                            <div className="form-control-plaintext form-control-sm">
                              {product.original_price}
                            </div>
                          </div>
                        </div>
                      </RB.Col>
                      <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-2 col-xxl-2 no-validation-icon">
                        <div className="mb-3">
                          <div className="floating-label-fancy">
                            <label>{isLargeScreen ? "" : "Sales Price"}</label>
                            <div className="form-control-plaintext form-control-sm">
                              {product.sales_price}
                            </div>
                          </div>
                        </div>
                      </RB.Col>
                      <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-1 col-xxl-2 no-validation-icon">
                        <div className="mb-3">
                          <div className="floating-label-fancy">
                            <label>{isLargeScreen ? "" : "Quantity"}</label>
                            <div className="form-control-plaintext form-control-sm">
                              {product.qty}
                            </div>
                          </div>
                        </div>
                      </RB.Col>
                      <RB.Col className="col-12 col-md-3 col-lg-4 col-xl-2 col-xxl-2 no-validation-icon">
                        <div className="mb-3">
                          <div className="floating-label-fancy">
                            <label>{isLargeScreen ? "" : "Total Price"}</label>
                            <div className="form-control-plaintext form-control-sm">
                              {product.sales_price * product.qty}
                            </div>
                          </div>
                        </div>
                      </RB.Col>
                    </RB.Row>
                  </RB.CardBody>
                </RB.Card>
              ))}

              <RB.Row className="g-3  justify-content-end align-items-center">
                <RB.Col className="col-12 col-md-4 col-xl-2 text-md-end ">
                  <h6 className="mb-0">Total</h6>
                </RB.Col>
                <RB.Col className="col-12 col-md-4 col-xl-auto no-validation-icon">
                  <div
                    className="bg-light bg-opacity-50 px-2 pe-3 py-1 rounded-3"
                    style={{
                      ...(window.innerWidth >= 1200
                        ? { minWidth: "100px" }
                        : {}),
                    }}
                  >
                    <span class="text-uppercase fw-bold small text-body-secondary">
                      Quantity
                    </span>
                    <p class="fw-medium text-sm fw-semibold mb-0">
                      {orderData?.order_total_qty
                        ? orderData?.order_total_qty
                        : ""}
                    </p>
                  </div>
                </RB.Col>
                <RB.Col className="col-12 col-md-4 col-xl-auto no-validation-icon ">
                  <div
                    className="bg-light bg-opacity-50 px-2 pe-3 py-1 rounded-3"
                    style={{
                      ...(window.innerWidth >= 1200
                        ? { minWidth: "150px" }
                        : {}),
                    }}
                  >
                    <span class="text-uppercase fw-bold small text-body-secondary ">
                      Price
                    </span>
                    <p class="fw-medium text-sm fw-semibold mb-0">
                      {orderData?.order_total}
                    </p>
                  </div>
                </RB.Col>
              </RB.Row>
            </RB.CardBody>
          </RB.Card>

          <>
            <h6>Payment Terms</h6>
            <hr className="hr-lg mt-1" />
          </>
          {orderData?.payment_terms && (
            <RB.Col md={4}>
              {/* <span className="text-uppercase fw-bold small text-body-secondary">
                Payment Terms
              </span> */}
              <p className="fw-medium text-sm text-body-secondary">
                {orderData?.payment_terms}
              </p>
            </RB.Col>
          )}

          {orderData?.material?.length > 0 || isShowEditMM ? (
            <>
              {isEditing ? (
                <RB.Card>
                  <RB.CardBody>
                    <div className="d-md-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                      <h6 className="mb-2 mb-md-0">Marketing Material</h6>
                      <div>
                        <RB.Button
                          variant="light"
                          onClick={handleAddMarketingField}
                        >
                          <AddCircleOutline className="me-2" />
                          Add Item
                        </RB.Button>
                        <RB.Button
                          variant="link"
                          onClick={handleCancelMarketingField}
                        >
                          Cancel
                        </RB.Button>
                      </div>
                    </div>
                    {marketingDynamic?.length > 0 && (
                      <>
                        {marketingDynamic
                          .filter((field) => field.status !== "deleted")
                          .map((field, index) => (
                            <RB.Card className="mb-2 bg-light-subtle1 border-0 border-bottom card rounded-0 border-dashed">
                              <RB.CardBody className="p-0">
                                <RB.Row className="gx-3 gy-2 align-items-center">
                                  <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 col no-validation-icon">
                                    <div className="mb-3">
                                      <RB.FloatingLabel
                                        label="Item"
                                        className="floating-label-fancy"
                                      >
                                        <RB.Form.Control
                                          as="select"
                                          name="item"
                                          className="form-control form-select form-select-sm"
                                          value={field.item}
                                          onChange={(e) =>
                                            handleMarketDynamic(index, e)
                                          }
                                        >
                                          <option value="">Category...</option>
                                          {itemList?.map((item) => (
                                            <option
                                              key={item.id}
                                              value={item.id}
                                            >
                                              {item.item_name}
                                            </option>
                                          ))}
                                        </RB.Form.Control>
                                      </RB.FloatingLabel>
                                    </div>
                                  </RB.Col>

                                  <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-2 col-xxl-2 no-validation-icon ">
                                    <div className="mb-3">
                                      <RB.FloatingLabel
                                        label="Price"
                                        className="floating-label-fancy"
                                      >
                                        <RB.Form.Control
                                          type="text"
                                          placeholder="Enter MRP"
                                          name="marketPrice"
                                          value={field.marketPrice}
                                          onChange={(e) =>
                                            handleMarketDynamic(index, e)
                                          }
                                          required
                                          readOnly
                                        />
                                      </RB.FloatingLabel>
                                    </div>
                                  </RB.Col>

                                  <RB.Col className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 col no-validation-icon">
                                    <div className="mb-3">
                                      <RB.FloatingLabel
                                        label="Quantity"
                                        className="floating-label-fancy"
                                      >
                                        <RB.Form.Control
                                          type="text"
                                          placeholder="Enter Quantity"
                                          name="qty"
                                          value={field.qty}
                                          onChange={(e) =>
                                            handleMarketDynamic(index, e)
                                          }
                                        />
                                      </RB.FloatingLabel>
                                    </div>
                                  </RB.Col>

                                  <RB.Col className="col-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3  no-validation-icon">
                                    <div className="mb-3">
                                      <RB.FloatingLabel
                                        label="Total Price"
                                        className="floating-label-fancy"
                                      >
                                        <RB.Form.Control
                                          type="text"
                                          //   placeholder="Enter Discounted Price"
                                          name="marketPrice"
                                          value={`${calculateTotalPrice(
                                            field.marketPrice,
                                            field.qty
                                          )}`}
                                          // onChange={(e) =>
                                          //   handleDynamicFieldChange(index, e)
                                          // }
                                          readOnly
                                        />
                                      </RB.FloatingLabel>
                                    </div>
                                  </RB.Col>

                                  <RB.Col className="col-12 col-md-auto col-lg-auto col-xl-auto col-xxl-auto">
                                    <RB.Button
                                      variant="link"
                                      className="text-dark p-0"
                                      onClick={() =>
                                        handleRemoveMarketingField(
                                          index,
                                          field.id
                                        )
                                      }
                                    >
                                      <DeleteOutline />
                                    </RB.Button>
                                    {/* {marketingDynamic.length - 1 === index && (
                    <RB.Button
                      variant="outline-dark"
                      className="btn-sm"
                      onClick={handleAddMarketingField}
                    >
                      <AddCircleOutline />
                    </RB.Button>
                  )} */}
                                  </RB.Col>
                                </RB.Row>
                              </RB.CardBody>
                            </RB.Card>
                          ))}

                        <RB.Row
                          className="g-3 me-md-5 
         justify-content-end align-items-center"
                        >
                          <RB.Col className="col-12 col-md-4 col-xl-2 text-md-end ">
                            <h6 className="mb-0">Total</h6>
                          </RB.Col>
                          <RB.Col className="col-12 col-md-4 col-xl-auto no-validation-icon">
                            <div
                              className="bg-light bg-opacity-50 px-2 pe-3 py-1 rounded-3"
                              style={{
                                ...(window.innerWidth >= 1200
                                  ? { minWidth: "100px" }
                                  : {}),
                              }}
                            >
                              <span class="text-uppercase fw-bold small text-body-secondary">
                                Quantity
                              </span>
                              <p class="fw-medium text-sm fw-semibold mb-0">
                                {totalMarketQty}
                              </p>
                            </div>
                          </RB.Col>
                          <RB.Col className="col-12 col-md-4 col-xl-auto no-validation-icon ">
                            <div
                              className="bg-light bg-opacity-50 px-2 pe-3 py-1 rounded-3"
                              style={{
                                ...(window.innerWidth >= 1200
                                  ? { minWidth: "180px", marginRight: 30 }
                                  : {}),
                              }}
                            >
                              <span class="text-uppercase fw-bold small text-body-secondary ">
                                Price
                              </span>
                              <p class="fw-medium text-sm fw-semibold mb-0">{`${totalMarketPrice.toFixed(
                                2
                              )}`}</p>
                            </div>
                          </RB.Col>
                        </RB.Row>
                      </>
                    )}

                    <h6>Note</h6>
                    <hr className="hr-lg mt-3" />

                    <RB.Col md={12} className="">
                      <div className="mb-3">
                        <RB.FloatingLabel
                          // label="Note"
                          controlId="bmNote"
                          className="floating-label-fancy"
                        >
                          <RB.Form.Control
                            as="textarea"
                            type="text"
                            placeholder="Enter Note here"
                            name="bmNote"
                            value={bmNote}
                            onChange={handleBmChange}
                            maxLength={500}
                            isInvalid={!!bmErrors.note}
                          />

                          <RB.Form.Control.Feedback type="invalid">
                            {bmErrors.note}
                          </RB.Form.Control.Feedback>
                        </RB.FloatingLabel>
                      </div>
                    </RB.Col>

                    <RB.Button variant="primary" onClick={handleSaveClick}>
                      Save
                    </RB.Button>
                  </RB.CardBody>
                </RB.Card>
              ) : (
                <>
                  <div className="row justify-space-between">
                    <h6 className="col cols-span-12">Marketing Material</h6>
                    <span className="col  text-end">
                      {isShowEditMM && (
                        <RB.Button onClick={handleEditClick}>Edit</RB.Button>
                      )}
                    </span>
                  </div>
                  <hr className="hr-lg mt-1" />

                  <RB.Card>
                    <RB.CardBody>
                      {isLargeScreen && (
                        <RB.Row className="gx-3 gy-2 align-items-center mb-2">
                          <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                            <span className="text-uppercase fw-bold small text-body-secondary">
                              Item
                            </span>
                          </RB.Col>

                          <RB.Col className="col-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                            <span className="text-uppercase fw-bold small text-body-secondary">
                              Price
                            </span>
                          </RB.Col>

                          <RB.Col className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                            <span className="text-uppercase fw-bold small text-body-secondary">
                              Quantity
                            </span>
                          </RB.Col>

                          <RB.Col className="col-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                            <span className="text-uppercase fw-bold small text-body-secondary">
                              Total Price
                            </span>
                          </RB.Col>
                        </RB.Row>
                      )}

                      {orderData?.material?.length > 0 ? (
                        <>
                          {orderData.material.map((field, index) => (
                            <RB.Card
                              key={field.id}
                              className="mb-2 bg-light-subtle1 border-0 border-bottom border-dashed card rounded-0 "
                            >
                              <RB.CardBody className="p-0">
                                <RB.Row className="gx-3 gy-2 align-items-center">
                                  <RB.Col className="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 no-validation-icon ">
                                    <div className="mb-3">
                                      <div className="floating-label-fancy">
                                        <label>
                                          {isLargeScreen ? "" : "Item"}
                                        </label>
                                        <div className="form-control-plaintext form-control-sm">
                                          {field.material_item_name}
                                        </div>
                                      </div>
                                    </div>
                                  </RB.Col>

                                  <RB.Col className="col-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3  no-validation-icon">
                                    <div className="mb-3">
                                      <div className="floating-label-fancy">
                                        <label>
                                          {isLargeScreen ? "" : "Price"}
                                        </label>
                                        <div className="form-control-plaintext form-control-sm">
                                          {field.price}
                                        </div>
                                      </div>
                                    </div>
                                  </RB.Col>

                                  <RB.Col className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 col no-validation-icon">
                                    <div className="mb-3">
                                      <div className="floating-label-fancy">
                                        <label>
                                          {isLargeScreen ? "" : "Quantity"}
                                        </label>
                                        <div className="form-control-plaintext form-control-sm">
                                          {field.qty}
                                        </div>
                                      </div>
                                    </div>
                                  </RB.Col>

                                  <RB.Col className="col-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3  no-validation-icon">
                                    <div className="mb-3">
                                      <div className="floating-label-fancy">
                                        <label>
                                          {isLargeScreen ? "" : "Total Price"}
                                        </label>
                                        <div className="form-control-plaintext form-control-sm">
                                          {field.price * field.qty}
                                        </div>
                                      </div>
                                    </div>
                                  </RB.Col>
                                </RB.Row>
                              </RB.CardBody>
                            </RB.Card>
                          ))}
                        </>
                      ) : (
                        <>
                          <RB.Card className="mb-2 bg-light-subtle1 border-0 border-bottom border-dashed card rounded-0 ">
                            <RB.CardBody className="p-0">
                              <RB.Row className="gx-3 gy-2 align-items-center">
                                <RB.Col className="no-validation-icon">
                                  No material items found.
                                </RB.Col>
                              </RB.Row>
                            </RB.CardBody>
                          </RB.Card>
                        </>
                      )}
                      <RB.Row className="g-3  justify-content-end align-items-center">
                        <RB.Col className="col-12 col-md-4 col-xl-2 text-md-end ">
                          <h6 className="mb-0">Total</h6>
                        </RB.Col>
                        <RB.Col className="col-12 col-md-4 col-xl-auto no-validation-icon">
                          <div
                            className="bg-light bg-opacity-50 px-2 pe-3 py-1 rounded-3"
                            style={{
                              ...(window.innerWidth >= 1200
                                ? { minWidth: "100px" }
                                : {}),
                            }}
                          >
                            <span class="text-uppercase fw-bold small text-body-secondary">
                              Quantity
                            </span>
                            <p class="fw-medium text-sm fw-semibold mb-0">
                              {orderData?.material_total_qty
                                ? orderData?.material_total_qty
                                : ""}
                            </p>
                          </div>
                        </RB.Col>
                        <RB.Col className="col-12 col-md-4 col-xl-auto no-validation-icon ">
                          <div
                            className="bg-light bg-opacity-50 px-2 pe-3 py-1 rounded-3"
                            style={{
                              ...(window.innerWidth >= 1200
                                ? { minWidth: "150px" }
                                : {}),
                            }}
                          >
                            <span class="text-uppercase fw-bold small text-body-secondary ">
                              Price
                            </span>
                            <p class="fw-medium text-sm fw-semibold mb-0">
                              {orderData?.material_total}
                            </p>
                          </div>
                        </RB.Col>
                      </RB.Row>
                    </RB.CardBody>
                  </RB.Card>
                </>
              )}
            </>
          ) : (
            ""
          )}

          {orderData?.order_notes && (
            <>
              <h6>Order Notes</h6>
              <hr className="hr-lg mt-1" />

              <RB.Col md={12}>
                {/* <span className="text-uppercase fw-bold small text-body-secondary">
                Payment Terms
              </span> */}
                <p className="fw-medium text-sm text-body-secondary">
                  {orderData?.order_notes}
                </p>
              </RB.Col>
            </>
          )}

          <>
            <h6>Shipment Information</h6>
            <hr className="hr-lg mt-1" />
          </>
          {/* <div className="d-md-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                <h6 className="mb-2 mb-md-0">Items</h6>
              </div> */}
          {orderData?.shipment?.length > 0 && (
            <>
              {orderData.shipment.map((shipment) => (
                <RB.Card>
                  <RB.CardBody className="p-3">
                    <div key={shipment.id}>
                      <h6 className="mb-2">{shipment.shipment_name}</h6>
                      <hr />

                      <RB.Card className="mb-2  border-0  card rounded-0 ">
                        <RB.CardBody className="p-0">
                          <RB.Row>
                            <RB.Col md={4}>
                              <span className="text-uppercase fw-bold small text-body-secondary ">
                                Type
                              </span>
                              <p className="fw-medium text-sm fw-semibold">
                                {shipment?.address_type}
                              </p>
                            </RB.Col>
                            {shipment.godown_id !== "0" && (
                              <RB.Col md={4}>
                                <span className="text-uppercase fw-bold small text-body-secondary">
                                  Godown
                                </span>
                                <p className="fw-medium text-sm fw-semibold">
                                  {shipment.godown_name}
                                </p>
                              </RB.Col>
                            )}
                            <RB.Col md={4}>
                              <span className="text-uppercase fw-bold small text-body-secondary">
                                Shipping Method
                              </span>
                              <p className="fw-medium text-sm fw-semibold">
                                {shipment?.shipment_method}
                              </p>
                            </RB.Col>{" "}
                            <RB.Col md={12}>
                              <span className="text-uppercase fw-bold small text-body-secondary">
                                Shipping Address
                              </span>
                              <p className="fw-medium text-sm fw-semibold">
                                {shipment?.address}
                              </p>
                            </RB.Col>{" "}
                          </RB.Row>
                          <h6 className="mb-2 mt-3">Products</h6>
                          <hr />
                          {isLargeScreen && (
                            <RB.Row className="gx-3 gy-2 align-items-center mb-2">
                              <RB.Col className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                <span className="text-uppercase fw-bold small text-body-secondary">
                                  Item
                                </span>
                              </RB.Col>

                              <RB.Col className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
                                <span className="text-uppercase fw-bold small text-body-secondary">
                                  Quantity
                                </span>
                              </RB.Col>
                            </RB.Row>
                          )}

                          {shipment.items.map((item) => (
                            <RB.Card
                              key={item.id}
                              className="mb-2 bg-light-subtle1 border-0 border-bottom border-dashed card rounded-0 "
                            >
                              <RB.CardBody className="p-0">
                                <RB.Row className="gx-3 gy-2 align-items-center">
                                  <RB.Col className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col no-validation-icon">
                                    <div className="mb-3">
                                      <div className="floating-label-fancy">
                                        <label>
                                          {isLargeScreen ? "" : "Product Name"}
                                        </label>
                                        <div className="form-control-plaintext form-control-sm">
                                          {item.product_name}
                                        </div>
                                      </div>
                                    </div>

                                    {/* <div className="mb-3">
                                        <RB.FloatingLabel
                                          label={
                                            isLargeScreen ? "" : "Product Name"
                                          }
                                          className="floating-label-fancy"
                                        >
                                          <RB.Form.Control
                                            type="text"
                                            placeholder="Product Name"
                                            value={item.product_name}
                                            readOnly
                                            className="form-control form-control-sm"
                                          />
                                        </RB.FloatingLabel>
                                      </div> */}
                                  </RB.Col>

                                  <RB.Col className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col no-validation-icon">
                                    <div className="mb-3">
                                      <div className="floating-label-fancy">
                                        <label>
                                          {isLargeScreen ? "" : "Quantity"}
                                        </label>
                                        <div className="form-control-plaintext form-control-sm">
                                          {item.item_qty}
                                        </div>
                                      </div>
                                    </div>

                                    {/* <div className="mb-3">
                                        <RB.FloatingLabel
                                          label={
                                            isLargeScreen ? "" : "Quantity"
                                          }
                                          className="floating-label-fancy"
                                        >
                                          <RB.Form.Control
                                            type="text"
                                            placeholder="Quantity"
                                            value={item.item_qty}
                                            readOnly
                                            className="form-control form-control-sm"
                                          />
                                        </RB.FloatingLabel>
                                      </div> */}
                                  </RB.Col>
                                </RB.Row>
                              </RB.CardBody>
                            </RB.Card>
                          ))}
                        </RB.CardBody>
                      </RB.Card>
                    </div>
                  </RB.CardBody>
                </RB.Card>
              ))}
            </>
          )}

          {props?.rowData?.comments && props?.rowData?.comments !== "" ? (
            <>
              <h6 className="mt-4">Comments</h6>
              <hr className="hr-lg mt-1" />
              <RB.Table
                responsive
                bordered
                hover
                striped
                className="table-responsive "
              >
                <thead>
                  <tr>
                    <th style={{ width: "5%" }}>Sr</th>
                    <th style={{ width: "35%" }}>Comment</th>
                    <th style={{ width: "25%" }}>Name</th>
                    <th style={{ width: "20%" }}>Role</th>
                    <th style={{ width: "15%" }}>Commented Date</th>
                  </tr>
                </thead>
                <tbody>
                  {props?.rowData?.comments.map((comment, index) => (
                    <tr key={comment.id}>
                      <td style={{ width: "5%" }}>{index + 1}</td>
                      <td style={{ width: "35%" }}>{comment.comment}</td>
                      <td style={{ width: "25%" }}>{comment.commenter_name}</td>
                      <td style={{ width: "20%" }}>{comment.commenter_role}</td>
                      <td style={{ width: "15%" }}>
                        {moment(comment.createdAt).format(
                          "DD-MM-YYYY HH:mm:ss A"
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </RB.Table>
            </>
          ) : (
            ""
          )}

          {props?.rowData?.pi_status === "0" &&
            props?.rowData?.approve_status == "0" &&
            (userProfile.employeeId === props?.rowData?.reporting_manager_id ||
              userProfile.employeeId ===
                props?.rowData?.head_reporting_manager_id) &&
            props?.rowData?.sales_cordinator_id === null &&
            props?.rowData?.order_status === "1" && (
              <>
                <h6>Comment</h6>
                <hr className="hr-lg mt-1" />
                <div>
                  <RB.Col md={12} className="no-validation-icon">
                    <div className="mb-3">
                      <RB.FloatingLabel
                        controlId="comment"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          as="textarea"
                          type="text"
                          placeholder="Enter Your Comment here"
                          name="comment"
                          value={comment}
                          onChange={handleInputChange}
                          maxLength={500}
                          isInvalid={!!errors.note}
                        />

                        <RB.Form.Control.Feedback type="invalid">
                          {errors.note}
                        </RB.Form.Control.Feedback>
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  {
                    <>
                      <RB.Button
                        className="me-2"
                        style={{ backgroundColor: "#37c830", color: "white" }}
                        onClick={handleAccept}
                        disabled={loadingAccept} // Disable button while loading
                      >
                        {loadingAccept ? (
                          <RB.Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          "Accept"
                        )}
                      </RB.Button>
                      <RB.Button
                        style={{ backgroundColor: "red", color: "white" }}
                        onClick={handleReject}
                        disabled={loadingReject} // Disable button while loading
                      >
                        {loadingReject ? (
                          <RB.Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          "Reject"
                        )}
                      </RB.Button>
                    </>
                  }
                </div>
              </>
            )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default View;
